/**
 * @generated SignedSource<<ba3009980940e826e07e3aaeb09f8123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAddItemToCart_item$data = {
  readonly defaultSkuId: string;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useAddItemToCart_item";
} | null;
export type useAddItemToCart_item$key = {
  readonly " $data"?: useAddItemToCart_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAddItemToCart_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultSkuId",
        "storageKey": null
      },
      "action": "LOG",
      "path": "defaultSkuId"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0c32095588d9dcc8c651f66e005b8b91";

export default node;
